import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Brand } from 'src/app/core/models/brand.model';
import { CarService } from 'src/app/core/services/car.service';
import { convertStrToUrl } from 'src/app/core/utils';

@Component({
  selector: 'app-other-brands',
  templateUrl: './other-brands.component.html',
  styleUrls: ['./other-brands.component.scss',],
})
export class OtherBrandsComponent implements OnInit {
  brands: Brand[] = [];

  constructor(
    private _carService: CarService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this.getBrands();
  }

  onBrandClick(brand: Brand) {
    const url = `brand/${convertStrToUrl(brand.name)}-car-subscription?brand=${brand.name}`;
    this._router.navigateByUrl(url);
    window.scroll({ top: 0, left: 0, behavior: 'smooth', });
  }

  getBrands() {
    this._carService.getBrands({ limit: 10, sortBy: 'listingPriority', }).subscribe({
      next: (res) => {
        this.brands = res.brands;
      },
    });
  }
}
